import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=2e29fe80"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e29fe80')) {
      api.createRecord('2e29fe80', component.options)
    } else {
      api.reload('2e29fe80', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=2e29fe80", function () {
      api.rerender('2e29fe80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/csgAdmin/business/components/DataForm.vue"
export default component.exports